import * as React from "react";
import { forwardRef } from "react";
const SvgPopInIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6 2L16 2L16 12L11 12L9 14L16 14C17.11 14 18 13.1 18 12L18 2C18 0.9 17.11 -7.78063e-08 16 -1.74846e-07L6 -1.04907e-06C4.9 -1.14524e-06 4 0.899998 4 2L4 9L6 7L6 2ZM7 18L7 16L3.41 16L13.24 6.17L11.83 4.76L2 14.59L2 11L6.11959e-07 11L0 18L7 18Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgPopInIcon);
export { ForwardRef as ReactComponent };
